<template>
  <div class="container my-3 my-md-5">
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-body">
            <a href="/export/deliverynoteopenpositions" type="button" class="btn btn-primary mt-2">Offene Lieferscheinpositionen (CSV)</a>
            <a href="/export/deliverynoteopenpositionstxt" type="button" class="btn btn-primary mt-2">Offene Lieferscheinpositionen (TXT)</a>
            <a href="/export/deathcertificates" type="button" class="btn btn-primary mt-2">Totenscheine (CSV)</a>
            <a href="/export/backorderbyvendor/xlsx" type="button" class="btn btn-primary mt-2">Backorder nach Händlern (XLSX)</a>
            <a href="/export/backordertoprocess/xlsx" type="button" class="btn btn-primary mt-2">Backorder zu bearbeiten (XLSX)</a>
            <a href="/export/backordercomplete/xlsx" type="button" class="btn btn-primary mt-2">Backorder komplett (XLSX)</a>
            <a href="/export/backorderwoinbound/xlsx" type="button" class="btn btn-primary mt-2">Backorder komplett ohne Zulauf (XLSX)</a>
            <a href="/export/inboundshipments/xlsx" type="button" class="btn btn-primary mt-2">Zulauf (XLSX)</a>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="card mt-3">
          <div class="card-body">
            <b-input-group>
                <pv-multi-select
                  id="select-vendors"
                  v-model="selectedVendors"
                  filter
                  display="chip"
                  :options="vendors"
                  optionLabel="text"
                  optionValue="value"
                  placeholder="Händlerauswahl"
                >
                </pv-multi-select>
            </b-input-group>
            <br>
            <b-btn class="mt-2" variant="primary" @click="getSalesStatistic" :disabled="requestInProgress">
              SalesExport <b-spinner v-if="requestInProgress"></b-spinner>
            </b-btn>
          </div>
        </div>
      </div>
    </div>
      <div class="row">
        <div class="col-md-12">
          <div class="card mt-3">
            <div class="card-body">
              <b-input-group>
                <b-form-input class="col-3" v-model="selectedYear"></b-form-input>
                <b-input-group-append>
                  <b-dropdown id="dropdown-1" class="" variant="primary">
                    <b-dropdown-item v-for="year in allYears" :key="year" @click="setYear(year)">{{year}}</b-dropdown-item>
                  </b-dropdown>
                </b-input-group-append>
              </b-input-group>
              <br>
              <b-link :href="'/export/packaging/'+this.selectedYear+'/xlsx'"><b-btn variant="primary">Verpackung (XLSX)</b-btn></b-link>
          </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="card mt-3">
            <div class="card-body">
              <b-input-group class="mb-2">
                <b-form-input id="deliveryTime" v-model="formattedDate" type="text" placeholder="H:m:s D-M-Y"></b-form-input>
                  <b-input-group-append>
                  <b-form-datepicker  v-model="selectedDate" button-only right start-weekday="1" aria-controls="deliveryTime"></b-form-datepicker>
                  <b-button @click="isCollapsOpen = !isCollapsOpen" class="">Marketaccounts
                    <b-icon v-if="!isCollapsOpen" icon="caret-down-fill" aria-hidden="true" scale="0.5"></b-icon>
                    <b-icon v-else icon="caret-up-fill" aria-hidden="true" scale="0.5"></b-icon>
                  </b-button>
                </b-input-group-append>
              </b-input-group>
                <b-collapse v-model="isCollapsOpen">
                  <div v-for="marketAccount in marketAccounts" :key="marketAccount.id">
                    <b-form-checkbox
                    v-model="marketAccount.selected"
                    :value="true"
                    :unchecked-value="false"
                    >{{marketAccount.name}}
                    </b-form-checkbox>
                  </div>
                </b-collapse>
              <br>
              <b-link :href="'/export/predelivery/'+formattedDate+'/xlsx'"><b-btn variant="primary">Vorversand </b-btn></b-link>
            </div>
          </div>
        </div>
      </div>
    <modal-error-component v-model="modalError"></modal-error-component>
  </div>
</template>

<script>
export default {
  props: ['marketAccounts'],
  data(){
    return {
      selectedYear: null,
      selectedDate: null,
      vendors: [],
      selectedVendors: [],
      isCollapsOpen: false,
      requestInProgress: false,
      modalError: {
        show: false,
        message: "unpopulated",
        error: "unpopulated",
        title: "unpopulated"
      },
    }
  },
  computed:{
    allYears(){
      const currentYear = new Date().getFullYear();
      const startYear = 2021;
      const years = [];

      for(let year = startYear; year <= currentYear; year++){
          years.push(year);
      }
      return years;
    },
    formattedDate(){
      return moment(this.selectedDate, "YYYY-MM-DD").format('DD.MM.YYYY')
    }
  },
  methods:{
    setYear(year){
      this.selectedYear = year;
    },
    getSalesStatistic(){
      this.requestInProgress = true;
      axios.post('/export/salesStatistic', {vendorIds : this.selectedVendors})
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'sales.csv');
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          this.requestInProgress = false;
        })
        .catch(error => {
          this.requestInProgress = false;
          this.modalError.show = true;
          this.modalError.title = "";
          this.modalError.message = "Beim Exportieren der Daten ist ein Fehler aufgetreten";
          this.modalError.error = error;
          console.log(error);
        });
    }
  },
  created(){
    this.selectedYear = new Date().getFullYear().toString();
    this.selectedDate = moment().format("YYYY-MM-DD")
    axios.get('/vendor/all_names')
      .then(response => {
          this.vendors = response.data;
          this.vendors = this.vendors.map(vendor => {
              return {text: vendor.name, value: vendor.id}
          });
      })
      .catch(error => {
          console.log(error);
      });
  },
}
</script>
